var XPortal = XPortal || {};

XPortal.PlaceFooterBtns = (function () {
    var self = {};

    const selector = '.edit-btns-wrapper_footer';
    const activeClass = 'at-bottom';
    let intervalId;

        self.Init = function () {
          if (intervalId) return;

          intervalId = setInterval(() => {
            const footer = document.querySelector(selector);
            if (!footer) return;

            clearInterval(intervalId);

            const isAtBottom = () => {
              const maxScroll =
                document.documentElement.scrollHeight - window.innerHeight;

              if (maxScroll <= 2) return false;

              return window.scrollY >= maxScroll - 2;
            };

            const update = () => {
              footer.classList.toggle(activeClass, isAtBottom());
            };

            window.addEventListener("scroll", update, { passive: true });
            window.addEventListener("resize", update);
            window.addEventListener("load", update, { once: true });

            const resizeObserver = new ResizeObserver(update);
            resizeObserver.observe(document.documentElement);
            resizeObserver.observe(document.body);

            requestAnimationFrame(update);
          }, 300);
        };

    return self;
})();
